import { GET_USER_MY_TEAM, GET_USER_MY_TEAM_SUCCESSFUL, GET_USER_MY_TEAM_FAILED, UPDATE_USER_MY_TEAM, UPDATE_USER_MY_TEAM_SUCCESSFUL, UPDATE_USER_MY_TEAM_FAILED } from "./actionTypes";

export const getUserMyTeam = updateUserIdMyteam => {
    return {
        type: GET_USER_MY_TEAM,
        payload: { updateUserIdMyteam }
    }
}

export const getUserMyTeamSuccessfull = userMyTeam => {
    return {
        type: GET_USER_MY_TEAM_SUCCESSFUL,
        payload: { userMyTeam }
    }
}

export const getUserMyTeamFailed = userMyTeam => {
    return {
        type: GET_USER_MY_TEAM_FAILED,
        payload: { userMyTeam }
    }
}

export const updateUserMyTeam = userMyTeam => {
    return {
        type: UPDATE_USER_MY_TEAM,
        payload: { userMyTeam }
    }
}

export const updateUserMyTeamSuccessfull = userMyTeam => {
    return {
        type: UPDATE_USER_MY_TEAM_SUCCESSFUL,
        payload: { userMyTeam }
    }
}

export const updateUserMyTeamFailed = userMyTeam => {
    return {
        type: UPDATE_USER_MY_TEAM_FAILED,
        payload: { userMyTeam }
    }
}